import { render, staticRenderFns } from "./FileUploadButton.vue?vue&type=template&id=63433ff0&scoped=true&"
import script from "./FileUploadButton.vue?vue&type=script&lang=js&"
export * from "./FileUploadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63433ff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63433ff0')) {
      api.createRecord('63433ff0', component.options)
    } else {
      api.reload('63433ff0', component.options)
    }
    module.hot.accept("./FileUploadButton.vue?vue&type=template&id=63433ff0&scoped=true&", function () {
      api.rerender('63433ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/FileUploadButton.vue"
export default component.exports